export const reservationKeys = {
  byId: (id: string) => ['reservation', id] as const,
  /** Lecture par le propriétaire connecté (`/me`). */
  mineById: (id: string) => ['reservation', id, 'mine'] as const,
  /** Lecture hors session, derrière le jeton de portée `reservation`. */
  publicById: (id: string) => ['reservation', id, 'public'] as const,
  allByEstimate: (estimateId: string) => ['reservations', 'estimate', estimateId] as const,
  byEstimate: (estimateId: string, isTreated?: boolean) =>
    ['reservations', 'estimate', estimateId, isTreated] as const,
  byEstimateResponse: (responseId: string) =>
    ['reservation', 'estimate-response', responseId] as const,
}
